<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Informe de Entrega de Premios</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="consultar" class="btn-info btn--bigger">
                        <i class="fa fa-search"></i><span>Consultar</span>
                    </button>
                    <button @click="exportar" class="btn-success btn--bigger">
                        <i class="fa fa-file-excel-o"></i><span>Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Información de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select v-model="form.bodega_id" name="bodega" id="bodega">
                                    <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                                        {{ bodega.descripcion }}
                                    </option>
                                </select>
                                <label for="bodega">Sucursal</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-8">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                    placeholder="Seleccione..."
                                    @search="searchClientes"
                                    id="cliente"
                                    @input="inputClientes"
                                    v-model="selectedClientes"
                                    :options="clientes"
                                    multiple
                                    label="nombre"
                                ></v-select>
                                <label for="cliente">Clientes</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                    placeholder="Seleccione..."
                                    id="supervisores_id"
                                    v-model="selectedSupervisores"
                                    :options="supervisores"
                                    @input="inputSupervisores"
                                    @search="searchSupervisores"
                                    multiple
                                    label="nombre"
                                ></v-select>
                                <label for="supervisor_id">Supervisores</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                placeholder="Seleccione..."
                                id="vendedor_id"
                                v-model="selectedVendedores"
                                :options="vendedores"
                                @input="inputVendedores"
                                @search="searchVendedores"
                                label="descripcion"
                                ></v-select>
                                <label for="vendedor_id">Vendedores</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="desde"
                                v-model="form.desde"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="hasta"
                                v-model="form.hasta"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="form-inline">
                            <label for="por_entregar">
                                <input type="radio" v-model="form.por_entregar" 
                                name="por_entregar" value="S" id="por_entregar">
                                <span>Por entregar</span>
                            </label>
                            <label for="pendientes">
                                <input type="radio" v-model="form.por_entregar" 
                                name="por_entregar" value="N" id="pendientes">
                                <span>Pendientes</span>
                            </label>
                            <label for="todas_entregar">
                                <input type="radio" v-model="form.por_entregar" 
                                name="por_entregar" value="T" id="todas_entregar">
                                <span>Todas</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Resultados de la Consulta</h5>
            </div>
            <div class="card__content">
                <vs-table
                    ref="tableSelect"
                    search
                    :max-items="maximoItems == ''?20:maximoItems"
                    :data="registros"
                    pagination
                >
                    <template slot="header">
                    <div class="form-inline">
                        <input-field  
                        class="input-field--stretch ml-3"
                        type="tel" 
                        v-mask="'###'"
                        v-model="maximoItems"
                        id="maximoItems"
                        placeholder
                        >
                            <span>Cantidad de registros:</span>
                        </input-field>
                    </div>
                    </template>
                    <template slot="thead">
                        <vs-th
                            :sort-key="columna.sortable?columna.nombre:null"
                            v-for="columna in columnas"
                            v-show="!columna.hidden"
                            :key="columna.nombre"
                        >
                            {{ columna.descripcion }}
                        </vs-th>
                    </template>
                    <template slot-scope="{ data }">
                        <vs-tr
                            :data="tr"
                            :key="index"
                            v-for="(tr, index) in data"
                        >
                            <vs-td v-show="!columna.hidden" :data="lodash.get(data[index], columna.nombre)" v-for="columna in columnas" :key="columna.nombre + index">
                                <button @click="verPedido(data[index])" class="btn--text btn-info" v-if="columna.nombre === 'numero_documento'">
                                    {{ lodash.get(data[index], columna.nombre) }}
                                </button>
                                <label v-else-if="columna.nombre === 'por_entregar'" :for="'por_entregar_' + data[index].id">
                                    <input :checked="data[index].por_entregar === 'S'" @change="changeEntregar(data[index])" type="checkbox" :id="'por_entregar_' + data[index].id"><span></span>
                                </label>
                                <span v-else>
                                    {{ columna.money?moneyFormat(lodash.get(data[index], columna.nombre)):lodash.get(data[index], columna.nombre) }}
                                </span>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        bodegas: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            supervisores: [],
            selectedSupervisores: [],
            clientes: [],
            selectedClientes: [],
            moneyFormat: moneyFormat,
            lodash: _,
            maximoItems: 20,
            buttons: [],
            form: {
                tipo_fecha: 'H',
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                vendedores_id:  [],
                tipo_consulta: 'N',
                clientes_id: [],
                supervisores_id: [],
                bodega_id: '',
                por_entregar: 'T'
            },
            selectedVendedores: [],
            path: url + '/revision-entrega-premios',
            vendedores: [],
            registros: [],
            columnas: [
                {
                    nombre: 'numero_documento',
                    descripcion: '# Cartilla'
                },
                {
                    nombre: 'cliente.descripcion',
                    descripcion: 'Cliente'
                },
                {
                    nombre: 'fecha',
                    descripcion: 'Fecha'
                },
                {
                    nombre: 'valor_total',
                    descripcion: 'Valor total'
                },
                {
                    nombre: 'total_pagado',
                    descripcion: 'Pagado'
                },
                {
                    nombre: 'saldo_total',
                    descripcion: 'Saldo'
                },
                {
                    nombre: 'por_entregar',
                    descripcion: 'Por entregar'
                }
            ]
        };
    },
    methods: {
        changeEntregar : function (pedido) {
            axios.post(url + '/logistica/pedidos/' + pedido.id + '/por-entregar').then(({data}) => {
                pedido.por_entregar = data.por_entregar;
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        verPedido: function (pedido) {
            window.open(url + '/logistica/pedidos/' + pedido.id + '/edit', '_blank');
        },
        searchSupervisores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.supervisores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open(
                "GET",
                url + "/search/usuarios?tipo=S&bodega_id=" + this.form.bodega_id + "&search=" + search,
                true
            );
            xmlhttp.send();
        },
        searchClientes: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.clientes = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open("GET", url + "/search/clientes?search=" + search, true);
            xmlhttp.send();
        },
        inputSupervisores: function () {
            this.form.supervisores_id.splice(0, this.form.supervisores_id.length);
            for (let i = 0; i < this.selectedSupervisores.length; i++) {
                this.form.supervisores_id.push(this.selectedSupervisores[i].id);
            }
        },
        inputClientes: function () {
            this.form.clientes_id.splice(0, this.form.clientes_id.length);
            for (let i = 0; i < this.selectedClientes.length; i++) {
                this.form.clientes_id.push(this.selectedClientes[i].id);
            }
        },
        exportar: function () {
            this.form.tipo_consulta = 'E';
            window.open(url + '/revision-entrega-premios' + this.serialize(this.form), '_blank');
        },
        serialize: function (obj) {
            return (
                "?" +
                Object.keys(obj)
                .reduce(function (a, k) {
                    let val = obj[k];
                    let esArray = false;
                    if (val instanceof Date) {
                    val = val.toLocaleDateString("en");
                    } else if (val instanceof Array) {
                    esArray = true;
                    let acumulador = "";
                    for (let i = 0; i < val.length; i++) {
                        acumulador += k + "%5B%5D=" + val[i];
                        if (i != val.length - 1) {
                        acumulador += "&";
                        }
                    }
                    val = acumulador;
                    a.push(val);
                    }
                    if (!esArray) a.push(k + "=" + encodeURIComponent(val));
                    return a;
                }, [])
                .join("&")
            );
        },
        consultar: function () {
            this.form.tipo_consulta = 'N';
            axios.get(url + '/revision-entrega-premios', {
                params: this.form
            }).then(({data}) => {
                this.registros = data;
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        searchVendedores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.vendedores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
            xmlhttp.send();
        },
        inputVendedores: function () {
            this.form.vendedores_id.splice(0, this.form.vendedores_id.length);
            for (let i = 0; i < this.selectedVendedores.length; i++) {
                this.form.vendedores_id.push(this.selectedVendedores[i].id);
            }
        }
    },
    mounted: function () {
        if (this.bodegas.length > 0) {
            this.form.bodega_id = this.bodegas[0].id;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/InformeEntregaPremios.vue